(ns hai.web-app.layout
  "Shared layout/nav for the Humble Web App

  Defines a main navigation bar (sidebar on desktop, bottom bar on mobile)
  "
  #?(:cljs (:require-macros hai.web-app.layout))
  #?(:cljs
     (:require
      [clojure.string :as str]
      [hai.mini-apps.common :as mini-apps]
      [hai.ui.components :as c]
      hai.ui.components.new-design.girouette
      [hai.ui.components.new-design.typography :as typography]
      [hai.ui.components.new-design.utils :refer [px->rem]]
      [hai.ui.components.tooltip :as tt]
      [hai.ui.icons :as icons]
      [hai.ui.rf-sugar :refer [<s >e]]
      [hai.ui.tokens :as t]
      [hai.web-app.add-menu :as add-menu]
      [hai.web-app.routing :as routing]
      [hai.web-app.universal-bar :as universal-bar]
      [lambdaisland.ornament :as o])
     :clj
     (:require
      [clojure.string :as str]
      [lambdaisland.ornament :as o]
      [hai.ui.components :as c]
      [hai.ui.icons :as icons]
      [hai.ui.rf-sugar :refer [<s >e]]
      [hai.ui.components.new-design.utils :refer [px->rem]]
      [hai.ui.components.new-design.typography :as typography]
      [hai.ui.tokens :as t])))

(o/defstyled text* typography/text
  {:color t/--hai-black-1})

(def menu-border (str "1px solid " t/--text-secondary-30))
(def menu-icon (icons/mui-icon :outlined :menu))
(def menu-open-icon (icons/mui-icon :outlined :menu_open))

(def nav-header-height 64)
(def navbar-width 176)
(def navbar-collapsed-width 64)

(o/defstyled item-text :span
  {:color t/--hai-black-1
   :font-size (px->rem 15)})

(o/defstyled nav-tag :span
  {:font-size (px->rem 10)
   :font-weight "600"
   :padding (str/join " " [(px->rem 2) (px->rem 6)])
   :border-radius (px->rem 4)
   :line-height "1.4"
   :margin-left "auto"
   :white-space "nowrap"}
  [:&.beta
   {:background-color t/--hai-purple-2
    :color t/--bg-1}]
  [:&.dev
   {:background-color t/--text-secondary-30
    :color t/--text-secondary}])

#?(:cljs
   (def main-nav-items
     [{:label    "Get set up"
       :route    :admin-ui/setup
       :matches? #{:admin-ui/setup}
       :icon     icons/rocket
       :developer-features? true}

      {:label    "Home"
       :route    :home/view
       :matches? #{:home/view}}
      {:label    "Notes"
       :route    :notes/view
       :matches? #{:notes/view :notes/detail}}
      {:label    "Tasks"
       :route    :tasks/view
       :matches? #{:tasks/view :tasks/detail}}
      {:label    "Contacts"
       :route    :contacts/view
       :matches? #{:contacts/view :contacts/detail}
       :icon     icons/outlined-people}
      {:label    "Tags"
       :route    :tags/view
       :matches? #{:tags/view}
       :icon     icons/outlined-label
       :beta?    true}
      ;; Outdated and currently not used or maintained. We will revisit these
      ;; and decide what to do later.
      ;; {:label    "Flows tasks"
      ;;  :route    :tasks/table
      ;;  :matches? #{:tasks/table :tasks/edit :tasks/run :tasks/results :tasks/result}
      ;;  :icon     icons/outlined-task_alt}
      {:label    "Progress"
       :route    :timelines/view
       :matches? #{:timelines/view}}
      ;; Outdated and currently not used or maintained. We will revisit these
      ;; and decide what to do later.
      #_{:label    "Connections"
         :route    :connections/table
         :matches? #{:connections/table :connections/new :connections/create
                     :connections/oauth-callback :connections/new-api-key :connections/show-new-key}
         :icon     icons/outlined-electrical_services}
      {:label    "People"
       :route    :user/groups
       :matches? #{:user/groups}
       :icon     icons/outlined-groups
       :developer-features? true}
      {:label "Spaces"
       :route :spaces/view
       :icon  icons/outlined-workspaces
       :matches? #{:spaces/view}
       :admin-only true}

      ;; Outdated and currently not used or maintained. We will revisit these
      ;; and decide what to do later.
      ;; {:label    "Activity"
      ;;  :route    :usage/my-events
      ;;  :matches? #{:usage/events :usage/my-events}
      ;;  :icon     icons/outlined-insights}
      ;; {:label    "Prompt library"
      ;;  :route    :ai-prompts/table
      ;;  :matches? #{:ai-prompts/table :ai-prompts/edit :ai-prompts.edit/sharing}
      ;;  :icon     prompts/icon}

      {:label    "Refer a friend"
       :route    :account/refer
       :matches? #{:account/refer}
       :icon     icons/outlined-card_giftcard}

      {:label    "Mini-apps"
       :route    :admin-ui/mini-apps
       :matches? #{:admin-ui/mini-apps}
       :legacy?  true
       :icon     mini-apps/icon}
      {:label    "Chat with AI"
       :route    :tasks/chats
       :matches? #{:tasks/chats :tasks/chats-by-id}
       :icon     icons/outlined-chat
       :legacy?  true}
      {:label    "Assistants"
       :route    :tasks/knowledge
       :matches? #{:tasks/knowledge :tasks/knowledge-config :tasks/knowledge-crud-new}
       :icon     mini-apps/icon
       :legacy?   true}
      {:label    "Knowledge"
       :route    :sources/table
       :matches? #{:sources/table :sources/new :sources/create :ai-sources/show}
       :icon     icons/outlined-storage
       :legacy?  true}
      ;; Outdated and currently not used or maintained. We will revisit these
      ;; and decide what to do later.
      ;; {:label    "Automations"
      ;;  :route    :admin-ui/flows
      ;;  :matches? #{:admin-ui/flows :tasks/create}
      ;;  :icon     icons/outlined-plumbing
      ;;  :beta?    true}

      {:label "Component library"
       :route :component-library/view
       :icon icons/outlined-web
       :matches? #{:component-library/view}
       :admin-only true
       :developer-features? true}

      ;; Outdated and currently not used or maintained. We will revisit these
      ;; and decide what to do later.
      ;; {:label    "Journal"
      ;;  :route    :entity/my-events
      ;;  :matches? #{:entity/my-events}
      ;;  :icon     icons/outlined-book}
      ;; {:label    "Credits"
      ;;  :route    :account/credits
      ;;  :matches? #{:account/credits}
      ;;  :icon     icons/outlined-payments}
      ]))

(o/defstyled initials-avatar :span
  :flex :items-center :justify-center :flex-shrink-0
  {:width            (px->rem 24)
   :height           (px->rem 24)
   :border-radius    "50%"
   :background-color t/--colour-chalk
   :color            t/--text-secondary-50
   :font-size        (px->rem 10)
   :font-weight      "700"
   :letter-spacing   "0.03em"
   :user-select      "none"})

(defn initials
  "Up to two uppercased initials from a full/display name."
  [full-name]
  (->> (str/split (or full-name "") #"\s+")
       (keep first)
       (take 2)
       (apply str)
       str/upper-case))

(o/defstyled avatar-tooltip-trigger :span
  :flex :items-center :flex-shrink-0)

#?(:cljs
   (defn profile-icon
     "Initials avatar for the viewer; falls back to the person icon when we
      don't have a name."
     []
     (let [{:user/keys [full-name display-name]} @(<s :auth/identity)
           person-name (or full-name display-name)]
       (if (seq person-name)
         [initials-avatar (initials person-name)]
         [icons/outlined-person]))))

#?(:cljs
   (defn profile-icon-with-email-tooltip
     "Avatar that reveals the viewer's email on hover.

      The trigger is a plain `:span` carrying the styled class by name — an
      Ornament component doesn't forward refs, which Radix's trigger
      composition needs, and the tooltip silently never opens. The empty
      `:title` suppresses the nav item's own native tooltip underneath."
     []
     (let [email (first (:user/email @(<s :auth/identity)))]
       (if email
         [tt/tooltip {:content email}
          [:span {:class (str avatar-tooltip-trigger) :title ""}
           [profile-icon]]]
         [profile-icon]))))

#?(:cljs
   (def profile-nav-item
     {:label    "My profile"
      :route    :admin-ui/profile
      :matches? #{:admin-ui/profile}
      :icon     profile-icon}))

(o/defstyled nav-item :a
  :flex :items-center {:gap (px->rem 9)}
  :cursor-pointer
  {:padding (str/join " " [(px->rem 12) (px->rem 12) (px->rem 12) (px->rem 18)])
   :border-left (str "3px solid transparent")
   :border-top-right-radius (px->rem 8)
   :border-bottom-right-radius (px->rem 8)
   :height        (px->rem 48)
   :margin (str/join " " [(px->rem 4) "auto"])
   :color "inherit"
   :text-decoration "none"}
  [:svg {:width (px->rem 24) :height (px->rem 24)}]
  [#{:&:hover :&.inactive:hover :&.active}
   {:background-color t/--property-1}]
  [:&.active {:font-weight 600
              :background-color t/--card-cream
              :border-left      (str "3px solid " t/--hai-dark-purple)}
   [item-text {:color t/--hai-dark-purple}]
   [:.icon {:fill t/--hai-purple-1}]]
  [:&.inactive
   [:.icon {:fill t/--hai-grey-1}]]
  [:.shortcut {:margin-left "auto"}]
  ;; An item is either a place (`:route`) or an action (`:on-click`). The action
  ;; keeps the anchor's looks and gains its keyboard behaviour by hand — an
  ;; `<a>` with no href is not a control to a screen reader or the Enter key.
  ([{:keys [route matches? class icon beta? developer-features? open? on-click shortcut] :as menu-item}]
   #?(:cljs
      (let [route-data (when route @(<s [:route/data route]))
            resolved-icon (or icon (:icon route-data))
            active? (and matches? (matches? @(<s :routing/current-route-name)))
            label (or (:label menu-item) (:label route-data))
            collapsed? (not open?)
            activate (fn [e] (.preventDefault e) (on-click))]
        [:<>
         (cond->
          {:class (cond-> (or class []) active? (conj "active") (not active?) (conj "inactive"))}
           route    (assoc :href (routing/href route) :target routing/link-target)
           on-click (assoc :role "button"
                           :tab-index 0
                           :on-click activate
                           :on-key-down (fn [e]
                                          (when (#{"Enter" " "} (.-key e))
                                            (activate e))))
           collapsed? (assoc :title label))
         (when resolved-icon [:div.icon [resolved-icon]])
         [item-text label]
         (cond
           beta? [nav-tag {:class "beta"} "Beta"]
           developer-features? [nav-tag {:class "dev"} "Dev"])
         (when shortcut [universal-bar/kbd {:class "shortcut"} shortcut])]))))

(defn show-menu-item?
  "Filters `main-nav-items` against the viewer's role and flags.
   Each item may set:
     :admin-only          — only visible when viewer is admin
     :beta?               — hidden unless beta-features flag is on
     :developer-features? — hidden unless developer-features flag is on
     :legacy?             — only visible to users marked :user/legacy?
                            (inverse: shows for legacy holdouts, hides
                            from everyone else)"
  [{:keys [admin-only beta? developer-features? legacy?] :as _menu-item}]
  (and (or @(<s :auth/admin?) (not admin-only))
       (or (not beta?) @(<s :feature-flag/beta-features?))
       (or (not developer-features?) @(<s :feature-flag/developer-features?))
       (or (not legacy?) @(<s :auth/legacy?))))

(defn pretty-email [user]
  (-> user :user/email first
      ; \u200B is ZERO-WIDTH SPACE and behaves like <wbr> = line break opportunity
      (str/replace "." "\u200B.")
      (str/replace "_" "\u200B_")
      (str/replace "@" "\u200B@")))

(o/defstyled navbar-footer :div
  {:background-color t/--property-2
   :border-top (str "1px solid " t/--property-3)
   :flex-shrink "0"}
  :text-sm
  ([{:keys [open?]}]
   #?(:cljs
      (when (:logged-in? @(<s :auth/identity))
        [nav-item (assoc profile-nav-item
                         :open? open?
                         :icon profile-icon-with-email-tooltip)]))))

(o/defstyled brand-word :span
  {:color t/--hai-black-1
   :font-size (px->rem 16)
   :font-weight "500"
   :white-space "nowrap"})

(o/defstyled nav-brand :a
  :flex :items-center :flex-shrink-0
  {:gap (px->rem 8)
   :color "inherit"
   :text-decoration "none"}
  [:svg {:width (px->rem 24) :height (px->rem 24)}]
  ([]
   #?(:cljs
      [:<>
       {:href   (routing/href :home/view)
        :target routing/link-target}
       [icons/humble-logo-squidge-dark]
       [brand-word "Humble"]])))

(o/defstyled hamburger-button :button
  :flex :items-center :cursor-pointer
  {:width            (px->rem 40)
   :height           (px->rem 40)
   :border           "none"
   :border-radius    (px->rem 8)
   :padding-left     (px->rem 8)
   :background-color "transparent"}
  [:&:hover {:background-color t/--hai-white-2}]
  [:svg {:width (px->rem 24)
         :height (px->rem 24)
         :fill t/--hai-black-1}]
  ([]
   (let [open? @(<s :nav/navbar-open?)]
     [:<>
      {:aria-label (if open? "Collapse menu" "Expand menu")
       :on-click #(>e [:nav/navbar-toggle])}
      (if open? [menu-open-icon] [menu-icon])])))

#?(:cljs
   (defn search-nav-item
     "Search is an action, not a place — it opens the command palette. It rides
      in the rail as an item like any other, because the boxed trigger it
      replaces looked like a field you could type into, which it never was.

      Fully-qualified keywords rather than `::universal-bar/…`: the alias only
      exists in this file's cljs branch, and the styles compile on the JVM."
     [{:keys [open?]}]
     [nav-item {:label    "Search"
                :icon     icons/outlined-search
                :open?    open?
                ;; The collapsed rail is 64px wide — no room beside the icon.
                :shortcut (when open? universal-bar/shortcut-label)
                :on-click #(>e [:hai.web-app.universal-bar/open])}]))

(o/defstyled desktop-nav :nav
  :flex :flex-col :fixed
  {:top              "0"
   :left             "0"
   :width            (px->rem navbar-collapsed-width)
   :height           "100vh"
   :background-color t/--property-2
   :overflow         "hidden"
   :z-index          "250"
   :border-right     menu-border}
  ;; The hamburger comes first and the brand after it, so the button keeps its
  ;; place while the brand appears and disappears around it.
  [:.nav-header :flex :items-center
   {:height (px->rem nav-header-height) :flex-shrink "0" :padding-left (px->rem 12)}
   [nav-brand {:display "none"}]]
  [:.nav-body {:position "relative" :flex "1" :min-height "0"}]
  [:.nav-items
   {:position         "absolute" :inset "0"
    :display          "flex" :flex-direction "column"
    :background-color t/--property-2}
   [item-text {:display "none"}]
   [:>.scroll {:flex "1 1 auto" :overflow-y "auto" :overflow-x "hidden" :min-height "0"}]]
  [:&.open
   {:width (px->rem navbar-width)}
   [item-text {:display "inline"}]
   [:.nav-header
    [nav-brand {:display "flex"}]]
   [:.nav-items
    {:opacity "1"
     :pointer-events "auto"}]]
  ([{:keys [open?]}]
   #?(:cljs
      [:<>
       {:class (when open? "open")}
       [:div.nav-header [hamburger-button] [nav-brand]]
       [:div.nav-body
        [:div.nav-items
         (into [:div.scroll [search-nav-item {:open? open?}]]
               (comp (filter show-menu-item?)
                     (map (fn [menu-item] [nav-item (assoc menu-item :open? open?)])))
               main-nav-items)
         [navbar-footer {:open? open?}]]]])))

(o/defstyled desktop-chrome :div
  {:background-color t/--hai-white-2}
  :flex :flex-col :h-100vh
  [:#main :flex :flex-col :flex-grow :overflow-y-auto
   ;; Always reserve the vertical scrollbar's gutter so content width is the same
   ;; whether or not the scrollbar is present. Without this a page that grows past
   ;; the viewport (e.g. a tasks board filling in after its loading skeletons)
   ;; gains a scrollbar that narrows the content and shifts the layout sideways.
   {:margin-left      (px->rem navbar-collapsed-width)
    :scrollbar-gutter "stable"}]
  [:&.navbar-open
   [:#main {:margin-left (px->rem navbar-width)}]]
  ([body]
   #?(:cljs
      (let [open? @(<s :nav/navbar-open?)]
        [:<>
         {:class (when open? "navbar-open")}
         [desktop-nav {:open? open?}]
         [:main#main body]
         [universal-bar/palette]
         [add-menu/modals]]))))

(o/defstyled title-bar :div
  "Title bar container intended to be used as the first child of the page component"
  :flex :flex-row
  :w-full
  :justify-between)

(defn top-bar-menu
  "Title bar menu intended to be used as the first child of the page component"
  [{:keys [nav]}]
  #?(:cljs
     (let [active-route @(<s :routing/current-route-name)
           current-route @(<s :routing/current-route)
           path-params (:path-params current-route)]
       [c/TabNavRoot
        (doall
         (for [{:keys [title route-name]} nav]
           ^{:key route-name}
           [c/TabNavLink
            {:active (= active-route route-name)
             :href   (:path @(<s [:routing/route-details route-name path-params]))
             :target routing/link-target}
            title]))])))

(defn breadcrumb-label
  [data]
  (or (:label/short data)
      (:label data)))

(defn- route-data->breadcrumbs
  [route-data]
  (or (:breadcrumbs route-data)
      [(breadcrumb-label route-data)]))

(o/defstyled breadcrumb-link :a
  :cursor-pointer
  {:color "inherit" :text-decoration "none"}
  ;; Render the anchor content directly rather than recursing into the styled
  ;; `:a` component — delegating to the 2-arity would wrap a second <a> inside
  ;; this one (invalid DOM nesting).
  ([crumb]
   #?(:cljs
      (let [data @(<s [:route/data crumb])]
        [:<>
         {:href   (apply routing/href (if (vector? crumb) crumb [crumb]))
          :target routing/link-target}
         (breadcrumb-label data)])))
  ([crumb label]
   #?(:cljs
      [:<>
       {:href   (apply routing/href (if (vector? crumb) crumb [crumb]))
        :target routing/link-target}
       label])))

(o/defstyled breadcrumbs :div
  :sticky :top-0 :z-100
  :flex {:gap (px->rem 9)} :items-center
  {:padding (str/join " " [(px->rem 24) "0" (px->rem 16) "0"])
   :background-color t/--hai-white-2}
  [:svg :cursor-pointer {:fill t/--text-secondary-60}]
  [:at-media {:max-width "768px"} {:display "none"}]
  ([props]
   (let [route-data @(<s [:routing/current-route-data])
         crumbs (butlast
                 (remove nil?
                         (-> []
                             (into (route-data->breadcrumbs route-data))
                             (into (:breadcrumbs props)))))
         separator [:span ">"]]
     (-> [:<> [breadcrumb-link :home/view "Home"]]
         (conj separator)
         (into (comp (map (fn [crumb]
                            (cond
                              (keyword? crumb) [breadcrumb-link crumb]
                              (string? crumb) [:span crumb]
                              (map? crumb) [breadcrumb-link (:route crumb) (:label crumb)])))
                     (interpose separator))
               crumbs)))))

(o/defstyled sticky-form-bottom-bar :div
  :sticky :bottom-0
  :flex :justify-end
  {:padding (str/join " " [(px->rem 16) "0"])
   :background-color t/--bg-2})

(o/defstyled page :div
  "Layout for pages (view component for routes). First pass a title bar component followed by any
  number of child components that go into the main area."
  :w-full
  {:padding (str/join " " ["0" (px->rem 45) (px->rem 45)])}
  [:svg :fill-current]
  [:.main
   :flex :flex-col :gap-3
   {:margin-top (px->rem 72)}]
  [:at-media {:max-width "768px"}
   {:padding "0"}])

(o/defstyled content :div
  :flex :flex-col {:gap (px->rem 24)}
  {:margin-top (px->rem 36)})

(o/defstyled more-menu-button :div
  :cursor-pointer
  [:circle {:bounding-box-behaviour :contained
            :color t/--hai-off-white-2
            :size "56px"}]
  ([]
   [:<>
    {:on-click (fn [_] (prn 'foo))}
    [icons/filled-more_horiz {:style {:width "32px"
                                      :height "32px"
                                      :fill t/--hai-dark-purple}}]]))

(o/defstyled more-menu :div
  ([more-actions]
   [:<>
    [c/DropdownMenuRoot
     [c/DropdownMenuTrigger
      [c/Button
       {:variant "ghost"}
       [more-menu-button]]]
     (into [c/DropdownMenuContent]
           (comp (remove (fn [action]
                           (when (contains? action :active?)
                             (not (:active? action)))))
                 (map (fn [{:keys [title on-select] :as action}]
                        [c/DropdownMenuItem
                         {:onSelect on-select}
                         title])))
           more-actions)]]))

(o/defstyled heading :div
  :flex {:gap (px->rem 16)}
  :items-center
  {:margin (str/join " " ["0" "0" (px->rem 8)])}
  [:h1 :inline-block]
  [:>svg {:fill t/--hai-dark-purple
          :width (px->rem 40)
          :height (px->rem 40)}]
  ([{:keys [more-actions] :as props} & children]
   (let [{route-data :data} @(<s :routing/current-route)]
     (-> [:<>
          (when-let [icon (or (:icon props) (:icon route-data))]
            [icon])
          (when-let [label (or (:label props) (:text props) (:label route-data))]
            [:h1 label])
          (when (and more-actions @(<s :auth/admin?))
            [more-menu more-actions])]
         (into children)))))

(o/defstyled lead :span
  {:font-size (px->rem 22)
   :line-height (px->rem 32)
   :color t/--hai-grey-1}
  ;; Hide the big page heading on narrow viewports; the mobile header
  ;; already shows brand + route context.
  [:at-media {:max-width "768px"} {:display "none"}])

(o/defstyled card-lead typography/text
  {:font-weight "600"})

(o/defstyled card* :div
  [:& [:.container :flex {:gap (px->rem 80)}]]
  {:padding (str/join " " [(px->rem 60) (px->rem 45)])
   :background-color t/--hai-off-white-1})

(o/defstyled card card*
  ([{:keys [lead steps step-info faq]}]
   [:<>
    [card-lead lead]
    [:div.container
     steps
     step-info]
    [:div.container
     faq]]))

(o/defstyled h3* :h3
  {:font-size (px->rem 24)
   :font-weight "600"
   :color t/--hai-dark-purple})

(o/defstyled card-steps :div
  {:flex-grow "2"}
  ;; :w-100%
  [h3* {:margin (str/join " " [(px->rem 30) "0"])}]
  [:& [:.steps {:margin-left (px->rem 20) :list-style "decimal"}]]
  ([& steps]
   [:<>
    [h3* "Steps"]
    (into [:ol.steps] steps)]))

(o/defstyled card-step :li
  [:.inner
   {:margin (str/join " " [(px->rem 20) "0"])}
   :flex :items-center {:gap (px->rem 20)}]
  ([& children]
   [:<> (into [:div.inner] children)]))

(o/defstyled card-info :div
  {:flex-grow "1"}
  [:& [:.info
       {:display "grid"
        :grid-template-columns "auto auto"
        :gap (px->rem 20)}]
   [:.time {:color t/--hai-dark-purple}]]
  [:span :whitespace-nowrap]
  [h3* {:margin (str/join " " [(px->rem 30) "0"])}]
  ([{:keys [time tools works]}]
   (-> [:<>
        [h3* "Setup information"]
        [:div.info
         [:span.time [text* "Setup time"]]
         [text* time]
         [text* "Tools involved"]
         [text* tools]
         [text* "How it works"]
         [text* works]]])))

(o/defstyled faq :div
  [h3* {:margin (str/join " " [(px->rem 30) "0"])}]
  ([content]
   [:<>
    [h3* "Frequently asked questions"]
    [text* content]]))

(o/defstyled lead* :div
  :flex {:gap (px->rem 32)}
  [:.lead {:flex "2"}]
  [:.buttons
   :flex :flex-col
   {:flex "1"
    :gap (px->rem 20)}]
  ;; Hide the big page heading on narrow viewports; the mobile header
  ;; already shows brand + route context.
  [:at-media {:max-width "768px"} {:display "none"}]
  ([& children]
   (into
    [:<>
     [:div.lead (first children)]]
    (rest children))))
